import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Button, Table, Form, Select, Radio, Row, Col, Space,
  Typography, Alert, Statistic, Divider, message
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const INVOICE_TYPES = [
  { value: 'normal_p', label: '增值税普通发票（纸质）' },
  { value: 'normal_e', label: '增值税普通发票（电子）' },
  { value: 'special_p', label: '增值税专用发票（纸质）' },
  { value: 'special_e', label: '增值税专用发票（电子）' },
];

const MOCK_ORDERS = [
  { key: '1', orderNo: 'CZ20260301001', amount: 5000.00, time: '2026-03-01 10:00:00' },
  { key: '2', orderNo: 'CZ20260315002', amount: 3000.00, time: '2026-03-15 14:30:00' },
  { key: '3', orderNo: 'CZ20260401003', amount: 2512.00, time: '2026-04-01 09:20:00' },
];

const MOCK_HEADER = {
  title: '深圳汇云科技有限公司', taxNo: '212121212121212',
  bankName: '中国建设银行', bankAccount: '31205588996623', bankAddress: '深圳市龙岗区',
};

const MOCK_ADDRESSES = [
  { key: '1', name: '张冬冬', phone: '0755-12345678', address: '深圳市龙岗区坂田街道星河WORLD TOWER A座' },
];

const MOCK_EMAILS = [
  { key: '1', email: 'sz@example.com' },
];

const InvoiceApply = () => {
  const navigate = useNavigate();
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [invoiceType, setInvoiceType] = useState('normal_p');
  const [receiveAddr, setReceiveAddr] = useState('1');
  const [receiveEmail, setReceiveEmail] = useState('1');

  const isPaper = invoiceType.includes('_p');
  const selectedAmount = MOCK_ORDERS.filter(o => selectedOrders.includes(o.key)).reduce((s, o) => s + o.amount, 0);

  const orderColumns = [
    { title: '充值单号', dataIndex: 'orderNo', width: 200 },
    { title: '金额(CNY)', dataIndex: 'amount', width: 150, render: (v) => <Text strong>{v.toFixed(2)}</Text> },
    { title: '充值时间', dataIndex: 'time', width: 200 },
  ];

  const headerColumns = [
    { title: '发票抬头', dataIndex: 'title', width: 220 },
    { title: '税号', dataIndex: 'taxNo', width: 200 },
    { title: '开户行', dataIndex: 'bankName', width: 150 },
    { title: '开户行账号', dataIndex: 'bankAccount', width: 180 },
    { title: '开户行地址', dataIndex: 'bankAddress', width: 150 },
  ];

  const handleSubmit = () => {
    if (selectedOrders.length === 0) { message.warning('请选择开票订单'); return; }
    message.success('开票申请已提交');
    navigate('/cost/invoices');
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button icon={<ArrowLeftOutlined />} type="text" onClick={() => navigate('/cost/invoices')} />
        <Title level={4} style={{ margin: 0 }}>申请开票</Title>
      </div>

      <Alert type="warning" showIcon style={{ marginBottom: 16, borderRadius: 8 }}
        message="单次开票最低金额为 5,000.00。请务必核对开票信息准确性，提交开票申请后不可再修改。" />

      {/* 金额统计 */}
      <Card bordered={false} style={{ marginBottom: 16 }}>
        <Row gutter={0}>
          {[
            { title: '可开票金额', value: 10512, color: '#fa8c16', prefix: '¥' },
            { title: '累计充值', value: 0, prefix: '¥' },
            { title: '历史已开票金额', value: 2.2, prefix: '¥', link: true },
            { title: '开票申请中金额', value: 0, prefix: '¥', link: true },
          ].map((item, i) => (
            <Col span={6} key={i} style={{ textAlign: 'center', borderRight: i < 3 ? '1px solid #f0f0f0' : 'none', padding: '8px 0' }}>
              <Statistic title={item.title} value={item.value} prefix={item.prefix} precision={item.value % 1 !== 0 ? 2 : 0}
                valueStyle={{ color: item.color || '#333', fontSize: 24 }} />
              {item.link && <Button type="link" size="small" style={{ marginTop: 4 }}>查看明细</Button>}
            </Col>
          ))}
        </Row>
      </Card>

      {/* 选择开票订单 */}
      <Card bordered={false} style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <Space>
            <span>已选开票金额</span>
            <Text strong style={{ color: '#fa8c16', fontSize: 18 }}>¥ {selectedAmount.toFixed(2)}</Text>
            <Button type="link" size="small" onClick={() => setSelectedOrders(MOCK_ORDERS.map(o => o.key))}>全部开票</Button>
          </Space>
        </div>
        <Table columns={orderColumns} dataSource={MOCK_ORDERS} rowKey="key" pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
          rowSelection={{ selectedRowKeys: selectedOrders, onChange: setSelectedOrders }} />
      </Card>

      {/* 发票抬头信息 */}
      <Card bordered={false} style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <Title level={5} style={{ margin: 0 }}>发票抬头信息</Title>
          <Space>
            <Button type="link" size="small" onClick={() => message.info('新增抬头')}>新增</Button>
            <Button type="link" size="small" onClick={() => navigate('/cost/invoices/manage')}>管理</Button>
          </Space>
        </div>
        <Table columns={headerColumns} dataSource={[MOCK_HEADER]} rowKey="title" pagination={false}
          rowSelection={{ type: 'radio', selectedRowKeys: [MOCK_HEADER.title], columnTitle: '选择' }} />
      </Card>

      {/* 发票类型 */}
      <Card bordered={false} style={{ marginBottom: 16 }}>
        <Form layout="vertical">
          <Form.Item label="发票类型" style={{ marginBottom: 16 }}>
            <Select value={invoiceType} onChange={setInvoiceType} style={{ width: 320 }} options={INVOICE_TYPES} />
          </Form.Item>

          {/* 接收方式 - 纸质：邮寄地址 */}
          {isPaper && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <Title level={5} style={{ margin: 0 }}>邮寄地址</Title>
                <Space>
                  <Button type="link" size="small" onClick={() => message.info('新增地址')}>新增</Button>
                  <Button type="link" size="small" onClick={() => navigate('/cost/invoices/manage')}>管理</Button>
                </Space>
              </div>
              <Radio.Group value={receiveAddr} onChange={(e) => setReceiveAddr(e.target.value)} style={{ width: '100%' }}>
                {MOCK_ADDRESSES.map(addr => (
                  <Card key={addr.key} size="small" hoverable style={{ marginBottom: 8, border: receiveAddr === addr.key ? '1px solid #1677ff' : '1px solid #f0f0f0', borderRadius: 8 }}
                    bodyStyle={{ padding: '12px 16px' }}>
                    <Radio value={addr.key}>
                      <Space split={<Divider type="vertical" />}>
                        <Text strong>{addr.name}</Text>
                        <Text>{addr.phone}</Text>
                        <Text type="secondary">{addr.address}</Text>
                      </Space>
                    </Radio>
                  </Card>
                ))}
              </Radio.Group>
            </div>
          )}

          {/* 接收方式 - 电子：邮箱 */}
          {!isPaper && (
            <div>
              <Title level={5}>电子邮箱</Title>
              <Radio.Group value={receiveEmail} onChange={(e) => setReceiveEmail(e.target.value)} style={{ width: '100%' }}>
                {MOCK_EMAILS.map(em => (
                  <Card key={em.key} size="small" hoverable style={{ marginBottom: 8, border: receiveEmail === em.key ? '1px solid #1677ff' : '1px solid #f0f0f0', borderRadius: 8 }}
                    bodyStyle={{ padding: '12px 16px' }}>
                    <Radio value={em.key}>{em.email}</Radio>
                  </Card>
                ))}
              </Radio.Group>
            </div>
          )}
        </Form>
      </Card>

      <Button type="primary" size="large" onClick={handleSubmit}>提交申请</Button>
    </div>
  );
};

export default InvoiceApply;
